module.exports = __webpack_public_path__ + "static/foundationspage-54dbeebe6dbe79913b5fa0d10cb675b9.png";